export default __webpack_public_path__ + "static/media/bookmark.020359a7.svg";